import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input,  Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from '../../../services/mysql.service';

// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, of} from 'rxjs';
// 
import { Subscription } from 'rxjs';
// import { ErrorObservable } from 'rxjs';
// 

import { FileUploaderService } from '../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from '../../../services/global-functions.service';
import { JobReportSubject } from '../../../shared/models/jobReportSubject.model';
import { DataUtil } from '@syncfusion/ej2-data';
import { JobSubject } from 'src/app/shared/models/jobSubject.model';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { HotToastService } from '@ngneat/hot-toast';
import { LegalDateTimeService } from '../../../services/legal-datetime.service';



@Component({
  selector: 'app-job-details-widget',
  templateUrl: './job-details-widget.component.html',
  styleUrls: ['./job-details-widget.component.css']
})
export class JobDetailsWidgetComponent implements OnInit {

 // @Input() item_id? = '';   // if a single id is sent will do data lookup.

 // setup as observable?
  @Input() item_id?; // impliments on changes.
  @Input() item_data?; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full

  newSubject: JobSubject;
  
  job: any;
  job_id;
  job_type: any;
  job_plaintiff_type: any;
  job_type_location: any;
  job_type_court: any;
  job_type_document: any;
  job_type_affidavit: any;
  report_brand_brand: any;
  invoice_brand_brand: any;
  job_subject_type: any;
  modalRef: BsModalRef;
  initialCount;
  job_plaintiffs: any;
  job_report_subjects: any;
  subjectReportList: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  job_start_date_words: string;
  job_start_date: Date;
  job_duration: string;
  job_subject_documents: any;
  subjects_urgent2: any;
  job_subjects_count: number;
  job_subjects_not_closed_count: number;
  subjects: Object;
  current_subject_count: any;
  DialogObj: any;
  JSON_job: string;
  returned_subjects: any;
  subjects_stages_only: any;
  current_subject_stages_only_count: any;
  true_subject_count: number;
  brand_users: any;
  report_brand_user: any;
  timeframe_surcharges: any;


  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     public toastr: HotToastService,
     public legalDate: LegalDateTimeService,
  ) {


  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

   }

   // check for changes. to load data.
   ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.job_id = changes.item_id.currentValue;
     // test to see if loads undefined better.
     // this.job_id = this.item_id;

     // stops error on subjects page not having a job id initally
     if(this.job_id >= 1){
      this.getJob(this.job_id);
       this.getJobSubjects(this.job_id) // count subjects
      this.getJobSubjectsStagesOnly(this.job_id) // count stages to take from subjects to know the real count.
      this.getJobsTableDataSubjects(this.job_id); // get subject counts
     }

      // :: Not needed to load for side 
      if (this.widget_size != 'side'){
      this.getJobPlaintiffs(this.job_id); 
      this.getJobReportSubjects(this.job_id);
      this.getJobSubjectDocumentsByJobID(this.job_id);
      }

    }
  }

ngOnInit(): void {
 // so that when subjects are created and page reloads counts are establlished again.
  if(this.job_id >= 1){
    this.getJob(this.job_id);
     this.getJobSubjects(this.job_id) // count subjects
    this.getJobSubjectsStagesOnly(this.job_id) // count stages to take from subjects to know the real count.
    this.getJobsTableDataSubjects(this.job_id); // get subject counts
   }
}


// Functions
getJob(job_id) {
  this._demoService.getJobID(job_id).subscribe(
     data => { this.job = data;
      let res = data[0];
     


    


      // sets the default holder to create a new subject. May 2023 create new subject Button
      this.newSubject = {
        job_id: res.job_id,
        job_reference_number: res.job_reference_number,
        number_subjects: 1,
        // existing_subjects_count: this.current_subject_count, // set so that increments in sql correctly
        existing_subjects_count: this.true_subject_count, // Updated to true count to take subject stages in to consideration 2 May 2023
        file_number: this.current_subject_count, // adds one in api loop
        reference_number: res.reference_number,
        created_by: this.gfunc.sessionUserId,
        is_active: '1',
        job_type_id: res.job_type_id,
        job_type_location_id: res.job_type_location_id,
        job_type_court_id: res.job_type_court_id,
        job_type_document_type_id: res.job_type_document_type_id,
        job_type_affidavit_type_id: res.job_type_affidavit_type_id,
        job_status: res.job_status_code,
        subject_service_type_id: 1,
        brand_report_user_id: res.brand_report_user_id
         };


      let metric_1_date_1 = this.legalDate.toAuditDate(res.created_date) ?? new Date(res.created_date * 1000);
      let metric_1_date_2 = new Date();
      
      this.job_start_date = metric_1_date_1;
      this.job_start_date_words = this.gfunc.dhm(metric_1_date_1);
      // tslint:disable-next-line:max-line-length
      let duration_calc = metric_1_date_2.getTime() - metric_1_date_1.getTime(); // milliseconds // bigger date first so no negatives
      this.job_duration = this.gfunc.dhm(duration_calc);


      // Run the job data queries.
     this.getJobType(res.job_type_id);
     this.getJobPlaintiffType(res.job_plaintiff_type_id);
     this.getJobTypeLocation(res.job_type_location_id);
     this.getJobTypeCourt(res.job_type_court_id);
     this.getJobTypeDocument(res.job_type_document_type_id);
     this.getJobTypeAffidavit(res.job_type_affidavit_type_id);
     this.getReportBrand(res.brand_report_id);
     this.getInvoiceBrand(res.brand_invoice_id); // get company invoice brand
     this.getJobSubjectType(res.job_subject_type_id);

     this.getReportBrandUser(res.brand_report_user_id); // exposing brand_report_user_id
     
     /*  this.getClientMapping(res.client_id);
      this.getClientInvoice(res.client_invoice_id);
      this.getClientContactSharmans(res.client_contact_id);
      this.getJobSubjectType(res.job_subject_type_id);
      this.getJobAgentAssigned(res.job_id);
      this.getReportBrandUser(res.brand_report_user_id); // get report brand user
      */
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }





 getJobSubjectType(job_subject_type_id) {
  this._demoService.getJobSubjectType(job_subject_type_id).subscribe(
     data => { this.job_subject_type = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobType(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
     data => { 
      this.job_type = data;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobPlaintiffType(job_plaintiff_type_id) {
  this._demoService.getJobPlaintiffType(job_plaintiff_type_id).subscribe(
     data => { this.job_plaintiff_type = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypeLocation(job_type_location_id) {
  this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
     data => { this.job_type_location = data;
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobTypeCourt(job_type_court_id) {
  this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
     data => { this.job_type_court = data; 
     // let res = data[0];
     // this.model.job_type_id = res.job_type_id;
     // this.getJobTypeLocations(res.job_type_id);
    
    
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobTypeDocument(job_type_document_type_id) {
  this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
     data => { this.job_type_document = data; 
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobTypeAffidavit(job_type_affidavit_type_id) {
  this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
     data => { this.job_type_affidavit = data; 
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getReportBrand(brand_report_id) {
  this._demoService.getBrandById(brand_report_id).subscribe(
    data => {
      this.report_brand_brand = data;
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }


 getInvoiceBrand(brand_invoice_id) {
  this._demoService.getBrandById(brand_invoice_id).subscribe(
    data => {
      this.invoice_brand_brand = data;
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }


 getJobPlaintiffs(job_id) {
  this._demoService.getJobPlaintiffs(job_id).subscribe(
     data => { this.job_plaintiffs = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobSubjectDocumentsByJobID(job_id) {
  this._demoService.getJobSubjectDocumentsByJobID(job_id).subscribe(
     data => { this.job_subject_documents = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 deleteJobPlaintiff(job_plaintiff_id) {
  if (confirm('Are you sure you want to delete this Plaintiff? ')) {
    this._demoService.deleteJobPlaintiff(job_plaintiff_id).subscribe(
       data => {
     // reset the plaintiff list.
     this.getJobPlaintiffs(this.job_id);
    //  this.toastr.warning('Plaintiff removed from job.');
         return true;
       },
       error => {
         console.error('Error deleting !');
        //  return Observable.throw(error);
       }
    );
}
}


deleteJobSubjectDocument(job_subject_document_id) {
  if (confirm('Are you sure you want to delete this document listing? ')) {
    this._demoService.deleteJobSubjectDocument(job_subject_document_id).subscribe(
       data => {
     // reset the plaintiff list.
     this.getJobSubjectDocumentsByJobID(this.job_id);
    //  this.toastr.warning('Document listing removed from job.');
         return true;
       },
       error => {
         console.error('Error deleting !');
        //  return Observable.throw(error);
       }
    );
}
}



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
this.gfunc.globalJobViewSkipRoute(this.job_id);
};



getJobReportSubjects(job_id) {
  this._demoService.getJobReportSubjects(job_id).subscribe(
     data => { this.job_report_subjects = data;
      // this.dataB = new DataManager({
      //     json: [data]
      //   });
      // map the results.
      // this.subjectReportList = this.job_report_subjects.map(s => ({
      //   subject_id: s.subject_id,
      //   subject_number: s.subject_number
      //    }));
     // console.log(this.subjectReportList);

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
  }



  deleteJobReportSubjects(job_id) {
      this._demoService.deleteJobReportSubjects(job_id).subscribe(
         data => {
       // reset the plaintiff list.
           return true;
         },
         error => {
           console.error('Error deleting !');
          //  return Observable.throw(error);
         }
      );

  }



/// get the job subjects counts
  getJobsTableDataSubjects(job_id) {
    this._demoService.getJobsTableDataSubjects(job_id).subscribe(
      data => {
        this.subjects_urgent2 = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent2 = DataUtil.parse.parseJson(data);

        this.job_subjects_count = this.subjects_urgent2.length;
        this.job_subjects_not_closed_count = this.subjects_urgent2.filter((item) => item.job_status !== 'CLOSED')
        .map((item) => +item.invoice_id).length;

        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }
 
  getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent) {
    this._demoService.getAssignedAgentsJobsSubjectsGrid(job_id, brand_id, job_status_code, assigned_agent).subscribe(
      data => {
        this.subjects_urgent2 = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.subjects_urgent2 = DataUtil.parse.parseJson(data);
        // console.log("Done loadng USER");
        // console.log(this.users);

        this.job_subjects_count = this.subjects_urgent2.length;
        this.job_subjects_not_closed_count = this.subjects_urgent2.filter((item) => item.job_status !== 'CLOSED')
        .map((item) => +item.invoice_id).length;


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }


  getJobSubjects(job_id) {
    this._demoService.getJobSubjects(job_id).subscribe(
      data => {
        this.subjects = data;
        let res = data[0];
        this.current_subject_count = Object(this.subjects).length; // counts the subjects.
        // this.getSubjectNotes(res.subject_id);
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getJobSubjectsStagesOnly(job_id) {
    this._demoService.getJobSubjectsStagesOnly(job_id).subscribe(
      data => {
        this.subjects_stages_only = data;
        let res = data[0];
        this.current_subject_stages_only_count = Object(this.subjects_stages_only).length; // counts the subjects.
        // this.getSubjectNotes(res.subject_id);


        this.true_subject_count = (this.current_subject_count - this.current_subject_stages_only_count);

      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  // syncfusion dialog simple sample
public onOpenDialog = function(event: any): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Require an Additional Subject',
    content: 'Press Create Subject below and a new subject will be created.',
    okButton: {  text: 'Create Subject', click: this.okClick.bind(this) },
    cancelButton: {  text: 'Cancel.', click: this.cancelClick.bind(this) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
private okClick(): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 console.log(JSON.stringify(this.job) );
//  console.log('Model: ' + this.model );
 this.JSON_job = JSON.stringify(this.job);
 // this.createJobSubjectsMultiple(this.JSON_job);



 this.createJobSubjectsMulipleJobButton(this.newSubject);
 this.DialogObj.hide();
}

private cancelClick(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}




  // create subjects
  public createJobSubjectsMulipleJobButton(model) {

    // I have now modified this function to carry across job type ids in the insert scrupt to the subject.
  //  model.number_subjects = 1; // set to default so that only one is created here.


console.log('sentJobID: ' + model.job_id);

    this._demoService.createJobSubjectsMulipleJobButton(model).subscribe(
      data => {
        this.returned_subjects = data; // this is the retuned json upon creation.
        this.toastr.success('Subjects Saving... We have added your subject(s).');
        // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

      //  this.gfunc.globalJobViewSkipRoute(model.job_id);
        // Setup annd the Currents before we redirec the page
        // Needs to be a Function to update the ObserveOnOperator.
        // this.newCTrace_id(this.latest_trace_id);
        // or this.cdata.changeCTrace_id("999");

        let cb = {
          ...this.returned_subjects,
          ...model
        }
        this.gfunc.insertLog_CreateSubject(cb);
            //return console.log(error);
            this.gfunc.globalJobViewSkipRoute(this.job_id);

       // return true;


      },
      error => {
        console.error(error)
        // console.log('Should be form Model' + model);
        // console.error('Error Creating a Trace Project!');
        this.toastr.error('Adding Subjects Failed :: Please try again!');
       // console.log(error(error));
        // this.toastr.success('Added New Subject!');
        this.gfunc.insertLog_CreateSubject_FAIL(model);

        //return console.log(error);
        this.gfunc.globalJobViewSkipRoute(this.job_id);
      }
    );
  }



  getBrandUsers(brand_report_user_id) {
    this._demoService.getBrandUsers(brand_report_user_id).subscribe(
       data => { this.brand_users = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

// need to get user details
getReportBrandUser(brand_report_user_id) {
  this._demoService.getUsersById(brand_report_user_id).subscribe(
     data => { this.report_brand_user = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getTimeframeSurcharges() {
  this._demoService.getTimeframeSurcharges().subscribe(
     data => { this.timeframe_surcharges = data;  },
     err => console.error(err),
      () => {
        // console.log('done loading Subject Service Types')
       // this.collection = Array (this.job_types, this.job_type_locations); // collection of all data
       // let mappedJSON = JSON.parse(mapped);
       // console.log('Mapped JSON Array: ' + mappedJSON);
      }
        );
 }



}
